import { EUROPEAN_BRANDS_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { useProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { recordPerformanceMark } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/recordPerformanceMark";
import { useLayoutElementsQueryKey } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useLayoutElementsQueryKey";
import {
  LAYOUT_ELEMENTS_TIMING_FETCH_END_KEY,
  LAYOUT_ELEMENTS_TIMING_FETCH_START_KEY,
} from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/consts";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { wrapAsyncFn } from "@faire/web--source/common/wrapAsyncFn";
import { ICategoryPageLayoutRequest } from "@faire/web-api--source/indigofair/data/ICategoryPageLayoutRequest";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useLayoutElementsResponse = () => {
  const categoryModel = useCurrentCategoryModel();
  const navigationPath = useCurrentNavigationPath();
  const { fetchCategoryPageLayoutElements } = useProductCacheStore([
    "fetchCategoryPageLayoutElements",
  ]);
  const isEuropeanBrandsCategory =
    categoryModel.urlId.id === EUROPEAN_BRANDS_URL_ID;

  const queryKey = useLayoutElementsQueryKey();

  return useQuery({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      wrapAsyncFn(
        () =>
          fetchCategoryPageLayoutElements(
            ICategoryPageLayoutRequest.build({
              navigation_path: navigationPath,
            }),
            isEuropeanBrandsCategory
              ? {
                  hide_brand_tile_free_shipping: true,
                }
              : undefined,
            { signal }
          ),
        {
          before: () =>
            recordPerformanceMark(LAYOUT_ELEMENTS_TIMING_FETCH_START_KEY),
          after: () =>
            recordPerformanceMark(LAYOUT_ELEMENTS_TIMING_FETCH_END_KEY),
        }
      ),

    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
